import { startCase } from "lodash";
import { t } from "@/i18n-js/instance";

type ParamValue = string | number | string[] | boolean;

export const getFormattedValue = (
  formValue: ParamValue,
  type: string,
): string => {
  if (type === "boolean") {
    return formValue ? t("yes") : t("no");
  }

  if (type === "humanize" && typeof formValue === "string") {
    return startCase(formValue);
  }

  if (type === "array" && Array.isArray(formValue)) {
    return formValue.join(", ");
  }

  return String(formValue);
};

export const formatValueDynamically = (
  value: string | number | boolean | string[],
) => {
  const type = typeof value;
  if (type === "boolean") {
    return value ? t("yes") : t("no");
  }

  if (Array.isArray(value)) {
    return value.join(", ");
  }

  return String(value);
};
